import React from 'react';
import { Box } from '@mui/material'
import {ScrollMenu} from 'react-horizontal-scrolling-menu'
import BodyPart from './BodyPart'
import '../styles/HeroBanner.css'
import ExerciseCard from './ExerciseCard';

const HorizontalScrollbar = ({data,bodyPart,setBodyPart,isBodyParts}) => {
  return (
    <ScrollMenu>
        {data.map((item)=>(
        <Box
key={item.id || item}
itemId={item.id||item}
title={item.id||item}
m='0 40px'>
{isBodyParts?<BodyPart  //isBodyParts- agar bodaypart a rha h to wo dikhao wrna exercisecard m item poora dikhao
item={item}
bodyPart={bodyPart}
setBodyPart={setBodyPart}
/>
:<ExerciseCard  exercise={item}/>}
        </Box>
        )
        )}
    </ScrollMenu>
  )
}

export default HorizontalScrollbar